import http from "../../../../util/axios";

export default {
  //查询语言与专题分类
  filterKeys(params){
    return http.get('/app/user/extensionCourse/filterKeys',  {params})
  },

  //查询拓展课程列表
  courseList(data){
    return http.post('/app/user/extensionCourse/courseList',  data )
  },

  //查询拓展课程描述
  courseDetail(params){
    return http.get('/app/user/extensionCourse/courseDetail',  {params} )
  }

}



// WEBPACK FOOTER //
// ./src/api/user/course/selectivecourse/index.js